import React, { useState } from 'react';
import Quickstart1 from '../images/portal/quickstart-1.webp';
import Quickstart2 from '../images/portal/quickstart-2.webp';
import Quickstart3 from '../images/portal/quickstart-3.webp';
import Quickstart4 from '../images/portal/quickstart-4.webp';
import BtnEnter from '../images/portal/btn-enter.webp';
import BtnEnterHover from '../images/portal/btn-enter-hover.webp';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { translate } from 'react-polyglot';

const Quickstart = ({ t }) => {
  const [videoToggle, setVideoToggle] = useState();

  const steps = [
    {
      title: t('create_passport'),
      img: Quickstart1,
      link: 'https://passport.zkcandy.io/',
    },
    {
      title: t('buy_eth'),
      img: Quickstart2,
      link: 'https://www.okx.com/trade-convert#from-page=navigation&from-action=web_header',
    },
    {
      title: t('bridge_eth'),
      img: Quickstart3,
      link: 'https://bridge.zkcandy.io/',
    },
    {
      title: t('participate_quest'),
      img: Quickstart4,
      link: 'https://app.layer3.xyz/campaigns/zkcandy',
    },
  ]

  return (
    <div id="quickstart" className="menu-container mb-10">
      <div className="border-2 border-[#ffffff80] bg-[#a776ff8c] rounded-2xl p-5">
        <div className="title text-[3rem] -tracking-[0.6rem] -ml-1">ZKcandy <span>{t('quickstart')}</span></div>
        <div className="desc font-montserrat">{t('quickstart_desc')}</div>

        <div className="steps-container grid grid-col-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4 font-montserrat">
          {steps.map((step, index) => (
            <div key={index} className="step relative border-2 rounded-xl overflow-hidden">
              <div className="absolute bottom-0 font-semibold text-lg lg:text-sm flex items-center bg-[#FFCC5A] text-[#46008f] backdrop-blur w-full">
                <div className="index m-1 w-6 text-center font-bold bg-[#46008f] text-white rounded-xl">
                  {index + 1}
                </div>
                <span className="pr-3 py-2">
                  {step.title}
                </span>
              </div>
              <div className="">
                <img src={step.img} alt={step.title} className="step-image" />
              </div>
              <div className="absolute right-1 bottom-0">
                <a href={step.link} target="_blank" rel="noopener noreferrer" className="step-link w-[100px] relative transition-all duration-200 hover:drop-shadow-[0_-6px_8px_#FF00C8]">
                  <img className="w-[60px] lg:w-[45px] absolute top-0 left-0 transition-all duration-200 hover:opacity-0" src={BtnEnter} alt="Enter" />
                  <img className="w-[60px] lg:w-[45px]" src={BtnEnterHover} alt="Enter" />
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="video-guide mt-5">
          <Accordion multiple activeIndex={videoToggle} onTabChange={(e) => setVideoToggle(e.index)}>
            <AccordionTab header={t('video_guide')}>
              <div>
                <iframe
                  src="https://player.vimeo.com/video/1077870379?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  title="ZKcandy Ecosystem Onboarding"
                ></iframe>
              </div>
              <script src="https://player.vimeo.com/api/player.js"></script>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default translate()(Quickstart);
